module.exports = __webpack_public_path__ + "img/pcs-logo-200x100.9c2110d2.png";